<template>
  <div class="review">
    <!-- v-if="ishiden !=1" -->
    <div class="revCals">
      <div class="revtitle">{{dataForm.name}}</div>
      <div class="revCalsli">
        <div class="revCalslileft">
          <span>报送单位：</span>
          <span class="revCalstxt">{{dataForm.deptName}}</span>
        </div>
        <div class="revCalsliright">
          <span>发布时间：</span>
          <span
            class="revCalstxt"
          >{{dataForm.publishTime?dataForm.publishTime.substring(0, 10):dataForm.publishTime}}</span>
        </div>
      </div>
      <div class="revCalsli">
        <div class="revCalslileft">
          <span>类型：</span>
          <span class="revCalstxt">{{dataForm.classDicName}}</span>
          <!-- {{dataForm.ClassDicName}} -->
        </div>
        <div class="revCalsliright">
          <span>关键字标签：</span>
          <span class="revCalstxt">{{dataForm.label}}</span>
        </div>
      </div>
      <div class="revCalsli" v-if="dataForm.description">
        <div class="revCalslileft">
          <span>课件：</span>
          <span
            text-decoration:underline
            @click="downloadres(dataForm)"
            class="revCalstxts"
            style="cursor: pointer;color:#1492ff;"
          >{{dataForm.zimu}}</span>

          <!-- <span
            text-decoration:underline
            @click="downloadres(dataForm)"
            class="revCalstxts"
            style="cursor: pointer;color:#1492ff;"
          >{{dataForm.zimu}}</span>
          <span
            @click="downPdf"
            style="cursor: pointer;color:#1492ff;margin-left:7px"
            class="revCalstxts"
            v-if="dataForm.isDown"
          >（下载）</span>
          <span
            style="cursor: pointer;color:#1492ff;margin-left:7px"
            class="revCalstxts"
            v-else
          >（下载）</span>-->
        </div>
      </div>

      <div class="revCalsli">
        <div class="revCalslileft">
          <span>内容简介：</span>
          <span class="revCalstxt">{{dataForm.context}}</span>
        </div>
      </div>
    </div>
    <div class="withreview">
      <el-form :model="reviewForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
        <div style="display:flex;justify-content: space-between;"></div>
        <div style="display:flex;justify-content: space-between;">
          <el-form-item prop="message" style="flex:4" v-if="tokens">
            <el-input
              type="textarea"
              v-model="reviewForm.message"
              ref="message"
              placeholder="请对资源内容发表你的评论吧！"
              :maxlength="100"
            ></el-input>
          </el-form-item>

          <el-form-item prop="messageto" style="flex:4" v-else>
            <el-input
              type="textarea"
              v-model="messageto"
              ref="message"
              placeholder="请对资源内容发表你的评论吧！"
              :maxlength="100"
              @click.native="inputNative"
            ></el-input>
          </el-form-item>

          <div class="btnsmint" @click="submitForm('ruleForm')">
            <div>
              <div>发表</div>
              <div>评论</div>
            </div>
          </div>
        </div>
      </el-form>
    </div>

    <div class="reviewtop">精彩评论 ( {{dataCount}} )</div>

    <div class="introducel" v-if="reviewData.length!==0">
      <div class="gaishu" v-for="(item,index) in reviewData" :key="index">
        <img class="gaiimg" :src="item.photo" />
        <div class="gaisuflex">
          <div class="gaisuname">{{item.createName}}</div>
          <div class="gaisutext">{{item.message}}</div>
          <div class="giveclbox">
            <div></div>
            <span class="give-time">{{item.createTime}}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <nodata></nodata>
    </div>
    <div class="pageblock">
      <el-pagination
        background
        prev-text="上一页"
        next-text="下一页"
        layout="total,prev, pager, next,jumper"
        :page-size="listQuery.limit"
        :current-page.sync="listQuery.page"
        :total="dataCount"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        v-if="dataCount>0"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { getInfo } from '@/utils/auth';
import * as resourceInfo from '@/api/resources/index.js';
export default {
  props: ['dataForm', 'ishiden'],
  data() {
    return {
      messageto: '',
      reviewForm: {
        id: 0,
        documentId: this.$route.query.id * 1,
        message: '',
        createTime: '2021-03-15T06:31:15.611Z',
        createId: '',
        createName: '',
        updateTime: '2021-03-15T06:31:15.611Z',
        updateId: 0,
        isDelete: true,
      },
      rules: {
        message: { required: true, message: '请输入您的评论', trigger: 'blur' },
      },
      dataCount: 0,
      listQuery: {
        page: 1,
        limit: 6,
        key: null,
      },
      user: [],
      reviewData: [],
      tokens: getInfo('tokens'),
    };
  },
  created() {
  
    this.getreviewList();
  },

  methods: {
    // 下载
    downPdf() {
      let a = document.createElement('a');
      a.setAttribute('download', this.dataForm.zimu);
      a.setAttribute('target', '_blank');
      a.setAttribute('href', this.dataForm.description);
      a.click();
    },
    downloadres(dataForm) {
      if (this.dataForm.description == '') {
        this.$notify({
          title: '失败',
          message: '没有文件可查看',
          type: 'warning',
        });
      } else {
        //下载文件
        window.open(this.dataForm.description);
      }
    },
    // 点击判断有没有登录、
    inputNative() {
      if (getInfo('tokens')) {
      } else {
        window.clikLogin();
      }
    },
    submitForm(formName) {
      if (getInfo('tokens')) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.reviewForm.createId = JSON.parse(getInfo('infos')).id * 1;

            this.reviewForm.createName = JSON.parse(getInfo('infos')).name;
            if (this.ishiden == 1) {
              this.reviewForm.documentId = this.dataForm.id;
            }
            resourceInfo.addDocreview(this.reviewForm).then((res) => {
              if (res.code == 200) {
                this.getreviewList();
                this.reviewForm.message = '';
                this.$notify({
                  title: '成功',
                  message: '评论成功',
                  type: 'success',
                });
              }
            });
          } else {
            // console.log('error submit!!');
            return false;
          }
        });
      } else {
        window.clikLogin();
      }
    },
    //获取评论列表
    getreviewList() {
      let para = {
        Page: this.listQuery.page,
        Limit: this.listQuery.limit,
      };
      if (this.ishiden == 1) {
        para.DocumentId = this.dataForm.id;
      } else {
        para.DocumentId = this.$route.query.id * 1;
      }
      resourceInfo.getByDocumentTalk(para).then((res) => {
        this.dataCount = res.count;
        this.reviewData = res.data;
      });
    },
    // 分页组件的页数跳转方法
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getreviewList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getreviewList();
    },
    // 点赞
    approve(item) {
      if (item.attention == false) {
        item.attention = true;
      } else {
        item.attention = false;
      }
    },
  },
};
</script>
<style  scoped >
.revCalstxts:hover {
  text-decoration: underline;
}
/* 整个页面 */
.review {
  /* width: 1000px; */
  /* height: 1050px; */
  background-color: #fff;
}
/* 标题样式 */
.reviewtop {
  height: 40px;
  line-height: 40px;
  margin-left: 8px;
  margin-top: 4px;
  font-size: 18px;
  font-weight: bold;
  color: #555;
  border-bottom: 1px solid #f2f2f2;
  padding-bottom: 10px;
}
/* 单个人评论的大盒子 */
.reviewpersonal {
  display: flex;
  /* height: 135px; */
  box-shadow: 4px 4px 12px rgba(127, 127, 127, 0.349019607843137);
  margin-top: 12px;
  padding: 5px 3px;
  border-radius: 5px;
}
/* 左盒子 */
.reviewpersonal > div:nth-child(1) {
  width: 60px;
  height: 60px;
}
/* 圆角头像框 */
.reviewpersonal > div:nth-child(1) > div {
  width: 40px;
  height: 40px;
  margin: 0 auto;
  margin-top: 10px;
}
.reviewpersonal > div:nth-child(1) > div > img {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  background-size: contain;
}
/* 右盒子 */
.reviewpersonal > div:nth-child(2) {
  width: 700px;
  /* height: 135px; */
}
/* 名称 */
.personaltop {
  width: 700px;
  height: 35px;
}
.personaltop > div {
  font-size: 14px;
  color: #ccc;
  line-height: 35px;
  margin-left: 16px;
}
/* 内容 */
.personalmetter {
  width: 700px;
  /* height: 60px; */
  /* text-indent:2em; */
}
.personalmetter > div {
  width: 680px;
  font-family: 'Arial Normal', 'Arial';
  font-size: 16px;
  color: #555555;
  margin-left: 16px;
  /* height: 60px; */
  /* white-space:nowrap;overflow:hidden;
    text-overflow : ellipsis; */
}
/* 点赞与日期 */
.personalfooter {
  width: 840px;
  height: 40px;
  display: flex;
  justify-content: space-between;
}
.personalfooter > div:nth-child(1) {
  background-color: #fff;
  width: 80px;
  height: 30px;
  border-radius: 20px;
  margin-top: 5px;
  margin-left: 16px;
  text-align: center;
  vertical-align: middle;
  line-height: 30px;
  background-color: rgba(215, 215, 215, 1);
}
.personalfooter > div:nth-child(1) > img {
  height: 16px;
}
.personalfooter > div:nth-child(2) {
  background-color: #fff;
  width: 140px;
  height: 30px;
  margin-top: 5px;
  margin-right: 36px;
  line-height: 30px;
  font-family: 'Arial Normal', 'Arial';
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
}
/* 分页 样式*/
.pageblock {
  margin-top: 20px;
  text-align: center;
}
.withreview {
  height: 70px;
  padding: 5px 0;
}
</style>
<style lang="scss" scoped>
.introducel {
  // width: 875px;
  background-color: rgba(255, 255, 255, 1);
  margin: 0 auto;
  margin-top: 40px;

  .gaishu {
    text-align: justify;
    text-justify: newspaper;
    word-break: break-all;
    border-radius: 5px;
    background-color: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    box-shadow: 2px 2px 5px rgb(215 215 215 / 35%);
    padding: 10px;
    color: #333333;
    margin-bottom: 25px;
    display: flex;
    // &:first-child {
    //   border-top-color: #e5e9ef;
    //   padding-top: 30px;
    // }
    .gaiimg {
      width: 45px;
      height: 45px;
      border-radius: 50%;
    }
    .gaisuflex {
      flex: 1;
      padding-left: 20px;
      .gaisuname {
        font-size: 16px;
      }
      .gaisutext {
        font-size: 16px;
        color: #555;
        padding-top: 10px;
        padding-right: 10px;
        line-height: 22px;
      }
      .giveclbox {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        .give-time {
          color: rgba(0, 0, 0, 0.349019607843137);
        }
        .givecl {
          display: flex;
          align-items: center;
          margin-top: 10px;
          background-color: #888;
          height: 30px;
          width: 75px;
          border-radius: 15px;
          justify-content: center;
          color: #fff;
          img {
            height: 15px;
            width: 15px;
            margin-right: 5px;
          }
        }
      }
    }
  }
}

.btnsmint {
  padding: 0 20px;
  background-color: #409eff;
  color: #fff;
  text-align: center;
  border-radius: 3px;
  font-size: 14px;
  display: flex;
  align-items: center;
  margin: 0 10px;
  height: 55px;
}

.revCals {
  padding: 15px 15px 20px 15px;
  border: 1px solid #f2f2f2;
  margin-bottom: 20px;
  .revtitle {
    font-size: 16px;
    font-weight: 700;
  }
  .revCalsli {
    padding-top: 15px;
    display: flex;
    align-items: center;
    font-size: 14px;
    .revCalslileft,
    .revCalsliright {
      flex: 1;
      .revCalstxt {
        color: #888;
      }
    }
  }
}
</style>

